import styled from 'styled-components';
import ArrowUp from './assets/arrowUp.svg';
import ArrowDown from './assets/arrowDown.svg';


export const Section = styled.div`
  width: 50%;
  .disable{
    border: none;
  }
  .dis{
    @media (max-width: 820px) {
      border-bottom: none !important;
    }
  }
  
  @media (max-width: 820px) {
    width: 100%;

    .disable{
      border-bottom: 1px solid var(--light-gray);
    }
  }
`;

export const Label = styled.div`
  height: 15px;
  text-align: left;
  letter-spacing: 2px;
  color: #6C6C6C;
  opacity: 1;
  font-size: 10px;
  padding: 19px;
  border-bottom: 1px solid var(--light-gray);
  display: flex;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  align-items: center;
`;

export const ContentRow = styled.div`
  padding: 8px 12px;
  border-bottom: 1px solid var(--light-gray);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  display: flex;
  align-items: center;
  @media (max-width: 820px) {
    white-space: normal;
  }

  p{
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
    max-width: 250px;
  }
  b{
    margin-right: 3px;
     color: #161615;
    font-weight: 600;
  }
  svg{
  min-width: 9px;
}
`;

export const ArrowUpIcon = styled(ArrowUp)`
  width: 9px;
  height: 17px;
  margin-right: 5px;
`;

export const ArrowDownIcon = styled(ArrowDown)`
  width: 9px;
  height: 17px;
  margin-right: 5px;
`;

export const TitleContainer = styled.div`
display: flex;
justify-content: center;
align-items: center;
width: 100%;
height: 37px;
/* UI Properties */
background: #E7E7E7 0% 0% no-repeat padding-box;
`
